<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <small class="ts-text-sm text-warning"
          ><i class="fas fa-exclamation-triangle"></i>
          {{ $t('employeecardactivator.doyouwanttodeactivetheoldcard') }}</small
        >
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('administration.employee.employeeCardActivator.reason')
              }}</label>
              <div>
                <input
                  type="text"
                  class="form-control"
                  v-model="model.reason"
                  :class="{ 'is-invalid': errors.has('reason') }"
                  autofocus
                />
                <div class="invalid-feedback" v-if="errors.has('reason')">
                  {{ errors.first('reason') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class=" btn-sm"
              @click.prevent="$emit('close')"
              :disabled="saving"
              >{{ $t('no') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              @click.prevent="submit"
              >{{ $t('yes') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  props: ['data'],
  name: 'confirm-deactivate-old-card-form',
  data() {
    return {
      model: {
        staff_id: '',
        serial_card: '',
        reason: '',
        status_id: 2
      },
      errors: new Errors(),
      saving: false
    }
  },
  created() {
    this.model.staff_id = this.data.staff_id
    this.model.serial_card = this.data.serial_card
  },
  methods: {
    submit() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('employeeCardActivator/update', {
          id: this.data.staff_id,
          ...this.model
        })
        .then(response => {
          return this.$store
            .dispatch('employeeCardActivator/fetch')
            .then(res => {
              this.saving = false
              this.$toasted.success(response.message)
              this.$emit('close')
              return Promise.resolve(res)
            })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  }
}
</script>
